import { createRoutine } from 'redux-saga-routines';

import * as types from 'types/modals';

/**
 * @type {ReduxSagaRoutine}
 */
export const deactivateTeamMemberModalRoutine = createRoutine(types.MODAL_DEACTIVATE_TEAM_MEMBER);
